import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/services/shared.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { LoaderComponent } from '../../shared/elements/loader/loader.component';
import { SafeHtmlPipe } from '../../shared/pipe/safe-html.pipe';
@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.css',
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, LoaderComponent, SafeHtmlPipe]
})
export class ContactUsComponent implements OnInit {

  public pageData:any;
  public loggedUser: any;

  constructor(
    private readonly http: HttpClient,
    private readonly sharedService: SharedService,
    public toaster: ToastrService
  ) {}

  ngOnInit() {
    this.loggedUser = JSON.parse(sessionStorage.getItem('currentUser')) || true;
    this.getContactUsData();
  }


  getContactUsData() {
    if (this.sharedService?.getContactUsData) {
      this.sharedService.getContactUsData().subscribe({
        next: response => {
          this.pageData = response;
        },
        error: () => {
          this.toaster.error('Failed to fetch Contact data');
        }
      });
    } else {
      console.error('SharedService or getContactUsData method is not defined.');
    }
  }

  
  hasUpcomingEvents(): boolean {
    return this.pageData?.some(item => item.category === 'Upcoming Events');
  }

  hasUpcomingDemo(): boolean {
    return this.pageData?.some(item => item.category === 'Upcoming Events Demo');
  }


}
